import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import List from "./pages/list/List";
import Single from "./pages/single/Single";
import New from "./pages/new/New";
import { BrowserRouter, Routes, Route , Navigate } from "react-router-dom";
import { roomsInputs, userInputs } from "./formSource";
import "./style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import {AuthContext} from "./context/AuthContext"
import Rooms from "./pages/rooms/Rooms";
import Edit from "./pages/rooms/Edit"
import NewRoom from "./pages/rooms/NewRoom";

function App() {
  const { darkMode } = useContext(DarkModeContext);

  const {currentUser}= useContext(AuthContext)


  // const currentUser = true;



  const RequireAuth = ({children}) => {
    return currentUser ? children : <Navigate to="/login"/>
  }

  console.log(currentUser)

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <BrowserRouter>
        <Routes>
          <Route path="/">
            <Route path="login" element={<Login />} />
            <Route index element={<RequireAuth> <Home/> </RequireAuth>} />
            <Route path="users">
              <Route index element={<RequireAuth><List /></RequireAuth>} />
              <Route path=":userId" element={<RequireAuth><Single /></RequireAuth>} />
              <Route
                path="new"
                element={<New inputs={userInputs} title="Add New User" />}
              />
            </Route>
            {/* <Route path="products">
              <Route index element={<List />} />
              <Route path=":productId" element={<Single />} />
              <Route
                path="new"
                element={<New inputs={productInputs} title="Add New Product" />}
              />
            </Route> */}
            <Route path="rooms">
              <Route index element={<RequireAuth><Rooms /></RequireAuth>} />
              <Route path="edit" element={<RequireAuth><Edit/></RequireAuth>} />
              <Route
                path="newroom"
                element={<RequireAuth><NewRoom inputs={roomsInputs} title="Add New Room" /></RequireAuth>}
              />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
